import { Component, OnInit, ViewChild } from '@angular/core';
import { NSSService } from '../shared/services/app.service';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { Router, NavigationStart, ActivatedRoute } from '@angular/router';
import { Station } from '../shared/interfaces/station';
import { GagestatsService } from 'app/gagestats/gagestats.service';
import { Agency } from 'app/shared/interfaces/agencies';
import { StationType } from 'app/shared/interfaces/stationtypes';
import { Toast } from 'angular2-toaster/src/toast';
import { GagePage } from 'app/shared/interfaces/gagepage';
import { Region } from 'app/shared/interfaces/region';
import { SettingsService } from 'app/settings/settings.service';
import { ConfigService } from 'app/config.service';
import { Config } from 'protractor';
import { ToasterConfig } from 'angular2-toaster';
import { ToasterService } from 'angular2-toaster/angular2-toaster';
import { ManageCitation } from 'app/shared/interfaces/managecitations';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import { LoaderService } from 'app/shared/services/loader.service';

@Component({
  selector: 'app-gagestats',
  templateUrl: './gagestats.component.html',
  styleUrls: ['./gagestats.component.scss']
})
export class GagestatsComponent implements OnInit {
  @ViewChild('gagepage',{static:true}) modalElement;
  public title: string;
  public timestamp: Date; // display a time stamp when they first get here.
  private navigationSubscription;
  public modalRef;
  public previousUrl;
  public selectedStations: Array<Station>;
  public agencies: Array<Agency>;
  public regions: Array<Region>;
  public stationTypes: Array<StationType>;
  public loggedInRole;
  public lastPageNumber;
  public currentPageNumber;
  public totalGages;
  public itemPerPage = [15,25,50,100]; 
  public perPage = 50;
  private configSettings: Config;
  public config: ToasterConfig = new ToasterConfig({ timeout: 20000 });
  public selectedParams: HttpParams;
  public counter = 0;
  public exportData = [];
  public disableExport = true;
  public gageCode: string;

  constructor(
    private _http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private _modalService: NgbModal, 
    private _nssService: NSSService,
    private gagestatsService: GagestatsService,
    public _settingsservice: SettingsService, 
    private _configService: ConfigService,
    private _loaderService: LoaderService,
    private _toasterService: ToasterService
    ){
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationStart) {
          this.router.navigated = false;
          this.previousUrl = e.url;
      }
    });
    this.configSettings = this._configService.getConfiguration();
    }

  ngOnInit() {
    this.loggedInRole = localStorage.getItem('loggedInRole');
    this.title = 'Gage Stats';
    this.timestamp = new Date();
    // subscribe to stations subject, which is set in the service's searchStations() function
    this._nssService.Stations.subscribe((s: Array<Station>) => {
      this.selectedStations = s;
    });
    // subscribe to all agencies
    this._nssService.agencies.subscribe((agencies: Array<Agency>) => {
      this.agencies = agencies;
    });
    // subscribe to all station types
    this._nssService.stationTypes.subscribe((stationtypes: Array<StationType>) => {
      this.stationTypes = stationtypes;
    });
    // get all regions
    this._settingsservice.getEntities(this.configSettings.gageStatsBaseURL + this.configSettings.regionURL).subscribe((regions: Array<Region>) => {
      this.regions = regions;
    });
    //subscribe to page number related information
    this._nssService.pageResponse.subscribe((pageText: string) => {
      var numbers = pageText.match(/[0-9]+/g); // [0-9] means to match any digit, the + means to match where there are multiple digits
      if (numbers != null) {
        this.currentPageNumber = Number(numbers[0]); // first occurrence of a number
        this.lastPageNumber = Number(numbers[1]); // second occurrence of a number
        this.totalGages = Number(numbers[2])
        this.disableExport = (this.totalGages > 3000)
      }
    });
    //subscribe to selected Filters
    this._nssService.selectedFilterParams.subscribe((selectedParams: HttpParams) => { 
      this.selectedParams = selectedParams;
    });
    
    this.route.params.subscribe(
      (params) => {
        if(this.route.snapshot.firstChild.params['code']){
          params = this.route.snapshot.firstChild.params['code']
          this.showGagePageModal(params);
        }
      }
    )
  } 

  showAddStationModal(): void{
    //TODO Accepted both changes to check to make sure this is correct
    this._nssService.setAddStationModal(true);
    this.gagestatsService.addStation();
  }

  public newPage(event){
    if (event >=1 && event <= this.lastPageNumber) {
      this._nssService.changePageNumber(event);
    } else {
      const toast: Toast = {
        type: 'warning',
        title: 'Error',
        body: 'Page Number Out of Bounds'
      };
      this._nssService.showToast(toast);
    }
  }

  public changePerPage(p){
    this._nssService.changePerPage(p);
  }

  public getAgencyName(aID) {
    if (this.agencies) {
      return (this.agencies.find(a => a.id === aID).name);
    }
  }

  public getRegionName(rID) {
    if (this.regions) {
      return (this.regions.find(r => r.id === rID).name);
    }
  }

  public getStationType(sID) {
    if (this.stationTypes) {
      return (this.stationTypes.find(s => s.id === sID).name);
    }
  }

  public showGagePageModal(s) {
    const gagePageForm: GagePage = {
      show: true,
      gageCode: s
  }
    this._nssService.setGagePageModal(gagePageForm);
  }

  public showManageCitationsModal() {
    const addManageCitationForm: ManageCitation = {
        show: true,
        addCitation: true,
        inGagePage: true,
        inGageStats: true,
    } 
    this._nssService.setManageCitationsModal(addManageCitationForm);
  }

  // Bulk Upload Button
  openBatchUpload(): void{
    this._nssService.setBatchUploadModalGS(true);
  }

  // Export 
  export(): void {
    this._loaderService.showFullPageLoad();
    this._toasterService.pop('info', 'Info', 'Exporting gages. Please wait, it could take a couple of minutes.');
    var allStations;
    this.counter = 0;
    this.exportData = [];
    this.selectedParams = this.selectedParams.set('pageCount', '100000');  
    this._nssService.getAllGages(this.selectedParams).subscribe(res => {
      allStations = res;
      this.fillData(allStations);
    });
  }

  public fillData(allStations) {
    this._http
    .get(this.configSettings.gageStatsBaseURL + this.configSettings.stationsURL + '/' + allStations[this.counter].code).subscribe(async res => {
      var station: any  = res;

      // Get NWIS Lat and Long for export 
      var NWISLatLong = await this.gagestatsService.getNWISInfo(station)
      .toPromise()
      .catch((err) => {
        return "N/A"
      });
      if (NWISLatLong == "N/A"){
        var NWISLat = "N/A"
        var NWISLong = "N/A"
      } else {
        var NWISArray = NWISLatLong.split(', ')
        NWISLat = NWISArray[0]
        NWISLong = NWISArray[1]
      }

      // station info
      this.exportData.push({
        StationNumber: station.code,
        StationName: station.name,
        StudyArea: station.region.code,
        StationType: station.stationType.name,
        Lat: station.location.coordinates[1],
        Long: station.location.coordinates[0],
        NWISLat: NWISLat,
        NWISLong: NWISLong,
        LocationSource: station.locationSource,
        IsRegulated: station.isRegulated.toString(),
        Agency: station.agency.code,
        CharacteristicName: null,
        CharacteristicValue: null,
        CharacteristicUnit: null,
        CharacteristicComments: null,
        StatisticName: null,
        StatisticValue: null,
        StatisticUnit: null,
        StatisticPreferred: null,
        StatisticYearsOfRecord: null,
        StatisticVariance: null, 
        StatisticLower90: null,
        StatisticUpper90: null,
        StatisticErrors: null,
        StatisticCitation: null,
        StatisticComments: null
      });          
      // Characteristic info
      station.characteristics.forEach(char => {
        this.exportData.push({
          StationNumber: station.code,
          StationName: station.name,
          StudyArea: null,
          StationType: null,
          Lat: null,
          Long: null,
          NWISLat: null,
          NWISLong: null,
          LocationSource: null,
          IsRegulated: null,
          Agency: null,
          CharacteristicName: char.variableType.name,
          CharacteristicValue: char.value,
          CharacteristicUnit: char.unitType.abbreviation,
          CharacteristicComments: char.comments,
          CharacteristicCitation: char.citation.title,
          StatisticName: null,
          StatisticValue: null,
          StatisticUnit: null,
          StatisticPreferred: null,
          StatisticYearsOfRecord: null,
          StatisticVariance: null, 
          StatisticLower90: null,
          StatisticUpper90: null,
          StatisticErrors: null,
          StatisticCitation: null,
          StatisticComments: null
        });
      });
      // Statistic info
      station.statistics.forEach(stat => {
        var variance = null;
        var upper = null;
        var lower = null;
        var error = null;
        var citation = null;
        if (stat.predictionInterval) {
          variance = stat.predictionInterval.variance;
          upper = stat.predictionInterval.upperConfidenceInterval;
          lower = stat.predictionInterval.lowerConfidenceInterval;
        }
        if (stat.statisticErrors && stat.statisticErrors.length > 0) { 
          error = '';
          stat.statisticErrors.forEach(e => {
            error += e.errorType.code +': ' + e.value;
          });
        }
        if (stat.citation) {
          citation = stat.citation.title;
        }

        this.exportData.push({
          StationNumber: station.code,
          StationName: station.name,
          StudyArea: null,
          StationType: null,
          Lat: null,
          Long: null,
          NWISLat: null,
          NWISLong: null,
          LocationSource: null,
          IsRegulated: null,
          Agency: null,
          CharacteristicName: null,
          CharacteristicValue: null,
          CharacteristicUnit: null,
          CharacteristicComments: null,
          StatisticName: stat.regressionType.name,
          StatisticValue: stat.value,
          StatisticUnit: stat.unitType.abbreviation,
          StatisticPreferred: stat.isPreferred,
          StatisticYearsOfRecord: stat.yearsofRecord,
          StatisticVariance: variance, 
          StatisticLower90: lower,
          StatisticUpper90: upper,
          StatisticErrors: error,
          StatisticComments: stat.comments,
          StatisticCitation: citation
        });
      });
    if (this.counter == (allStations.length - 1)) {
      this.createCSV();
    }
    this.counter ++;
    if (this.counter != allStations.length) {
      this.fillData(allStations);
    }
  },(error) => {
    if (this.counter == (allStations.length - 1)) {
      this.createCSV();
    }
    this.counter ++;
    if (this.counter != allStations.length) {
      this.fillData(allStations);
    }
  }); 
  }

  ConvertToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = '';

    for (let index in headerList) {
      row += headerList[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = '';
      for (let index in headerList) {
        let head = headerList[index];
        if (array[i][head] == null) { // if no value
          array[i][head] = ' ';
        }
        if (parseInt(index) == headerList.length - 1) {
          line += array[i][head].toString().replace(/,/g, "");
        } else {
          line += array[i][head].toString().replace(/,/g, "") + ',';
        }
      }
      line = line.replace(/(\r\n|\n|\r)/gm, ""); // remove line breaks from string (this is common in the comments field)
      str += line + '\r\n';
    }
    return str;
}

  public createCSV() {
    let csvData = this.ConvertToCSV(this.exportData, ['StationNumber', 'StationName', 'StudyArea', 'StationType', 'Lat', 'Long', 'NWISLat', 'NWISLong', 'LocationSource', 'IsRegulated', 'Agency',
                                                      'CharacteristicName', 'CharacteristicValue', 'CharacteristicUnit', 'CharacteristicComments', 'CharacteristicCitation',
                                                      'StatisticName', 'StatisticValue', 'StatisticUnit', 'StatisticPreferred', 'StatisticYearsOfRecord', 'StatisticVariance', 'StatisticLower90', 'StatisticUpper90', 'StatisticErrors', 'StatisticComments', 'StatisticCitation']);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    FileSaver.saveAs(blob, 'gageExport.csv');
    this._loaderService.hideFullPageLoad();
  }
}
